import { Injectable, inject } from '@angular/core';
import {
  DfProgressIndicatorService,
  DfProgressIndicatorContentSpinner,
  DfProgressIndicatorRef,
} from '@design-factory/design-factory';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private dfProgress = inject(DfProgressIndicatorService);
  private loadingCount = 0;
  private indicatorRef: DfProgressIndicatorRef | null = null;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this.isLoadingSubject.asObservable();

  show(): void {
    this.loadingCount++;
    this.isLoadingSubject.next(true);
    if (this.loadingCount === 1) {
      this.indicatorRef = this.dfProgress.open(
        new DfProgressIndicatorContentSpinner({ ariaLabel: 'Loading...' })
      );
    }
  }

  hide(): void {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }
    this.isLoadingSubject.next(this.loadingCount > 0);
    if (this.loadingCount === 0 && this.indicatorRef) {
      this.dfProgress.close(this.indicatorRef);
      this.indicatorRef = null;
    }
  }
}
